import { useState } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import { PlayFilled } from '@calm-web/icons';

import Image from '@/components/image/NextImage';
import LazyVideoOverlay from '@/components/ui/LazyVideoOverlay';
import { useAnalytics } from '@/hooks/analytics';

import messages from './messages';
import { Heading, PlayButton, VideoThumnbail, Wrapper } from './styles';

export type InstructorVideoProps = {
	instructorVideoHeading: MessageDescriptor;
	instructorVideoThumbnail: string;
	instructorVideoSrc: string;
	instructorVideoCaptionsSrc: string;
};

const InstructorVideo = ({
	instructorVideoHeading,
	instructorVideoThumbnail,
	instructorVideoSrc,
	instructorVideoCaptionsSrc,
}: InstructorVideoProps) => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();

	const [isVideoOpen, setIsVideoOpen] = useState(false);

	const onPlayButtonClick = () => {
		logEvent({
			eventName: 'Subpage : Video : Played',
			eventProps: {
				video_title: instructorVideoHeading.defaultMessage as string,
			},
		});
		setIsVideoOpen(true);
	};

	const onClose = () => {
		logEvent({
			eventName: 'Subpage : Video : Closed',
			eventProps: {
				video_title: instructorVideoHeading.defaultMessage as string,
			},
		});
		setIsVideoOpen(false);
	};

	return (
		<>
			<Wrapper>
				<Heading>{formatMessage(instructorVideoHeading)}</Heading>
				<VideoThumnbail>
					<Image fill src={instructorVideoThumbnail} alt="" style={{ objectFit: 'cover' }} />
					<PlayButton
						aria-label={formatMessage(messages.ctaLabel)}
						Icon={PlayFilled}
						onPress={onPlayButtonClick}
						color="white"
					/>
				</VideoThumnbail>
			</Wrapper>
			{isVideoOpen && (
				<LazyVideoOverlay
					src={instructorVideoSrc}
					closedCaptionsSrc={instructorVideoCaptionsSrc}
					closedCaptionsLabel="English"
					closedCaptionsLang="en"
					type="video/mp4"
					title={formatMessage(instructorVideoHeading)}
					onClose={onClose}
				/>
			)}
		</>
	);
};

export default InstructorVideo;
